// extracted by mini-css-extract-plugin
export default {"header":"Header_header__Q9nv6","logo":"Header_logo__yHbn4","link":"Header_link__zA0nP","linkActive":"Header_linkActive__onk7p","searchButton":"Header_searchButton__Qkthe"};